<template>
  <div>
      <div class="section-title">
        <h4 class="p-3 mb-2">
          <span>Your Amendments</span>
        </h4>
      </div>

      <template v-if="amendments.length">
        <AmendmentCard v-for="(amendment, index) in amendments" :key="index" 
        :amendment="amendment"
       />
      </template>

      <b-button variant="secondary" size="lg" class="w-100" @click.stop="goto">Add an amendment</b-button>

  </div>
</template>

<script>
import AmendmentCard from "./amendments/AmendmentCard";

import {http} from "@/services";


export default {
  name: 'Amendments',
  components:{
    AmendmentCard,
  },
  data() {
    return {
      show:false,
      amendments :[],
    }
  },
  mounted(){
    this.fetchAmendments();    
  },
  methods:{
    fetchAmendments() {
      http.get('amendment_list').then(
          response => {
            this.amendments = response.data
            console.log('this.amendments', this.amendments);
          }
      ).catch(
          error => {
            console.log(error)
          }
      )
    },
    goto() {
      this.$router.push({
        path: '/questionnaires/amendment_questionnaire'
      }).catch(
          error => {
            console.log(error)
          }
      )

    }


  },
}
</script>
